export enum LicensingStatusQueryType {
  GET_LICENSING_STATUS_BY_WORKSPACE = 'GET_LICENSING_STATUS_BY_WORKSPACE'
}
